<script setup>
import { onMounted, onBeforeUnmount, ref, computed } from "vue";

const props = defineProps({});

const isOpen = ref(props.opened);
const toggleState = () => {
  isOpen.value = !isOpen.value;
};
</script>

<template>
  <div class="flex flex-col border border-grey-border rounded-3xl">
    <header
      v-if="$slots.header"
      class="px-30 py-25 border-grey-border border-b">
      <slot name="header"></slot>
    </header>

    <div class="p-20 sm:p-30 grow">
      <slot></slot>
    </div>

    <footer
      v-if="$slots.footer"
      class="px-30 py-25 border-grey-border border-t xl:text-center">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style scoped lang="scss"></style>
